import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { reduxForm } from "redux-form";

import "../JournalListing.scss";
import JournalCategory from "./selectJournalCategory";
import JournalForm from "./nutritionJournalForm";
import SelectRecipe from "./selectRecipe";
import SelectFoodItem from "./selectFoodItem";
import FilterPanel, { PanelBody } from "../../../../sharedComponents/filterPanel";
import { addNutritionJournal, getNutrionJournalEntries } from "../../../../store/actions";

const AddToJournal = ({
	setToggleAddToJornal,
	history,
	getNutrionJournalEntries,
	courseOptions,
	toggleAddToJournal = false,
	onUpdate,
	initialRecipe,
	date
}) => {
	const queryString = `start_date=${moment(date ? date : new Date()).format("YYYY-MM-DD")}&end_date=${moment(
		date ? date : new Date()
	).format("YYYY-MM-DD")}`;
	const [isFoodItem, setIsFoodItem] = useState(false);
	const [isRecipie, setIsRecipe] = useState(false);
	const [selectedRecipe, setSelectedRecipe] = useState(null);

	const [selectedIngredient, setSelectedIngredient] = useState(null);
	const [atBottom, setAtBottom] = useState(false);

	const handleCancel = () => {
		setToggleAddToJornal(false);
		setSelectedRecipe();
		setSelectedIngredient();
		setIsFoodItem(false);
		setIsRecipe(false);
	};

	useEffect(() => {
		getNutrionJournalEntries(queryString);
		initialRecipe && setSelectedRecipe(initialRecipe);
	}, [getNutrionJournalEntries, initialRecipe, queryString]);

	return (
		<FilterPanel
			className="add-journal-panel hide-sub-header"
			show={toggleAddToJournal}
			toggle={() => handleCancel()}
			title="Add To Journal"
			toggleAtBottom={(event) => setAtBottom(event)}
			closeBtn>
			<PanelBody className="d-flex flex-column pb-0">
				{!isFoodItem && !isRecipie && !selectedIngredient && !selectedRecipe && (
					<JournalCategory setIsRecipe={setIsRecipe} setIsFoodItem={setIsFoodItem} />
				)}

				{isRecipie && !selectedRecipe ? (
					<SelectRecipe
						selectedRecipe={selectedRecipe}
						history={history}
						setSelectedRecipe={setSelectedRecipe}
						setIsRecipe={setIsRecipe}
						setIsFoodItem={setIsFoodItem}
						atBottom={atBottom}
						setAtBottom={setAtBottom}
						getNutrionJournalEntries={getNutrionJournalEntries}
						setToggleAddToJornal={setToggleAddToJornal}
					/>
				) : isFoodItem && !selectedIngredient ? (
					<SelectFoodItem
						selectedIngredient={selectedIngredient}
						setSelectedIngredient={setSelectedIngredient}
						setIsRecipe={setIsRecipe}
						setIsFoodItem={setIsFoodItem}
						setToggleAddToJornal={setToggleAddToJornal}
					/>
				) : selectedIngredient || selectedRecipe ? (
					<JournalForm
						selectedRecipe={selectedRecipe}
						setSelectedRecipe={setSelectedRecipe}
						selectedIngredient={selectedIngredient}
						setSelectedIngredient={setSelectedIngredient}
						setIsRecipe={setIsRecipe}
						setIsFoodItem={setIsFoodItem}
						setToggleAddToJornal={setToggleAddToJornal}
						meals={courseOptions}
						onUpdate={() => onUpdate && onUpdate()}
						initialRecipe={initialRecipe}
						date={date}
					/>
				) : null}
			</PanelBody>
		</FilterPanel>
	);
};

const mapDispatchToProps = { addNutritionJournal, getNutrionJournalEntries };

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm({
		form: "JournalForm"
	})(AddToJournal)
);
